import { compact } from 'lodash/fp';
import { createSelector } from 'reselect';
import { TextKey, RouteName } from '@mews-commander/enums';
import { canCurrentProfileViewSensitiveReports } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { getSimpleSearchResult } from './getSimpleSearchResult';
import { SearchResult } from './types';

export default createSelector(canCurrentProfileViewSensitiveReports, (canViewSensitiveReports) =>
    compact<SearchResult>([
        getSimpleSearchResult({
            routeName: RouteName.CashierDefault,
            titleKey: TextKey.Cashier,
        }),
        getSimpleSearchResult({
            routeName: RouteName.AccountingLedgerReportIndex,
            titleKey: TextKey.AccountingLedgerReport,
        }),
        getSimpleSearchResult({
            routeName: RouteName.PaymentReportIndex,
            titleKey: TextKey.PaymentReport,
        }),
        canViewSensitiveReports
            ? getSimpleSearchResult({
                  routeName: RouteName.AccountingReportIndex,
                  titleKey: TextKey.AccountingReport,
              })
            : null,
        getSimpleSearchResult({
            routeName: RouteName.BillReportIndex,
            titleKey: TextKey.BillReport,
        }),
        getSimpleSearchResult({
            routeName: RouteName.PostingJournalReportIndex,
            titleKey: TextKey.PostingJournalReport,
        }),
        canViewSensitiveReports
            ? getSimpleSearchResult({
                  routeName: RouteName.ManagerReportIndex,
                  titleKey: TextKey.ManagerReport,
              })
            : null,
        getSimpleSearchResult({
            routeName: RouteName.CreditCardReportIndex,
            titleKey: TextKey.CreditCardReport,
        }),
        getSimpleSearchResult({
            routeName: RouteName.ChargebackReportIndex,
            titleKey: TextKey.ChargebackReport,
        }),
        canViewSensitiveReports
            ? getSimpleSearchResult({
                  routeName: RouteName.MerchantBalanceReportIndex,
                  titleKey: TextKey.MerchantBalance,
              })
            : null,
        getSimpleSearchResult({
            routeName: RouteName.CityTaxReportIndex,
            titleKey: TextKey.CityTaxReport,
        }),
        canViewSensitiveReports
            ? getSimpleSearchResult({
                  routeName: RouteName.PayoutReportIndex,
                  titleKey: TextKey.PayoutReport,
              })
            : null,
    ])
);
